import unused_Vue from "vue";

export const ComponentCell = {
  name: "component-cell",
  props: ["component", "props", "keySuffix"],

  // Use render function for performance
  render(h) {
    // Get component constructor or async import function
    const comp = this.component;

    // Create the component with the props
    return h(comp, {
      props: this.props,
      // Optimize reactivity by using custom events instead of props for callbacks
      // on: this.getEventHandlers(),
    });
  },

  methods: {
    // getEventHandlers() {
    //   // Extract event handlers from props to reduce reactivity overhead
    //   const handlers = {};
    //   const props = this.props || {};

    //   Object.keys(props).forEach((key) => {
    //     if (typeof props[key] === "function") {
    //       handlers[key] = props[key];
    //       // Remove from props to avoid double binding
    //       delete props[key];
    //     }
    //   });

    //   return handlers;
    // },
  },
};
